import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import { DateFormatter } from '../../components/Grid/formatters/DateFormater';
import CurrencySummary from '../../components/Grid/CurrencySummary';

export default [
	{
		key: 'customerRegister',
		name: 'CNPJ',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 110,
	},
	{
		key: 'customerName',
		name: 'Cliente',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 250,
	},
	{
		key: 'type',
		name: 'Tp.',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 50,
	},
	{
		key: 'duplicate',
		name: 'Duplicata',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
	},
	{
		key: 'carrier',
		name: 'Portador',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 120,
	},
	{
		key: 'issueDate',
		name: 'Emissão',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
		formatter: DateFormatter,
	},
	{
		key: 'dueDate',
		name: 'Venc.',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
		formatter: DateFormatter,
	},
	{
		key: 'extensionDate',
		name: 'Prorrog.',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 80,
		formatter: DateFormatter,
	},
	{
		key: 'position',
		name: 'Posição',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 120,
	},
	{
		key: 'delay',
		name: 'Atraso',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 70,
	},
	{
		key: 'openOrders',
		name: 'Pedidos em Aberto',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 130,
	},
	{
		key: 'value',
		name: 'Valor',
		type: 'number',
		resizable: true,
		sortable: true,
		width: 100,
		formatter: CurrencyFormatter,
		summary: CurrencySummary,
	},
	{
		key: 'balance',
		name: 'Saldo',
		type: 'number',
		resizable: true,
		sortable: true,
		width: 100,
		formatter: CurrencyFormatter,
		summary: CurrencySummary,
	},
];
